import { render } from "./TwitchIcon.vue?vue&type=template&id=ecad1030"
const script = {}
script.render = render

export default script